const customColours = {
  White: '#ffffff',
  Black: '#000000',
  Slate: '#323737',
  LightSlate: '#d9dbde',
  Lime: '#bee13e',
  LightLime: '#edf7c7',
  Yellow: '#ffcb48',
  LightYellow: '#fce8c0',
  Orange: '#fd754c',
  LightOrange: '#ffdfd4',
  Lilac: '#e894ed',
  LightLilac: '#fde1ff',
  Blue: '#739bff',
  LightBlue: '#d6e3ff',
  Red: '#db3939',
  LightRed: '#fdd0d0',
  Osmium: '#6c818d',
  NeutralWhite: '#fff',
  NeutralLightest: '#f2f2f2',
  NeutralLighter: '#d9d9d9',
  NeutralLight: '#b3b3b3',
  Neutral: '#808181',
  NeutralDark: '#4d4e4e',
  NeutralDarker: '#1b1c1c',
  NeutralDarkest: '#020303',
  OuterSpaceLightest: '#eaebeb',
  OuterSpaceLighter: '#d5d8d8',
  OuterSpaceLight: '#6e7977',
  OuterSpace: '#30403e',
  OuterSpaceDark: '#263331',
  OuterSpaceDarker: '#131918',
  OuterSpaceDarkest: '#0e1312',
  WattleLightest: '#f9fbeb',
  WattleLighter: '#f2f7d9',
  WattleLight: '#e9f0b8',
  Wattle: '#dde89d',
  WattleDark: '#c9d87e',
  WattleDarker: '#b4c75e',
  WattleDarkest: '#a0b63e',
  EarlsGreenLightest: '#f7f8eb',
  EarlsGreenLighter: '#eff2b8',
  EarlsGreenLight: '#c7d278',
  EarlsGreen: '#b0bf3f',
  EarlsGreenDark: '#8c9832',
  EarlsGreenDarker: '#464c19',
  EarlsGreenDarkest: '#343912',
  SidecarLightest: '#fdfdf8',
  SidecarLighter: '#fcfbf1',
  SidecarLight: '#f5f3cf',
  Sidecar: '#f2efbb',
  SidecarDark: '#c1bf95',
  SidecarDarker: '#605f4a',
  SidecarDarkest: '#484738',
  TunaLightest: '#eaeaec',
  TunaLighter: '#d6d6da',
  TunaLight: '#706f7d',
  Tuna: '#333246',
  TunaDark: '#282838',
  TunaDarker: '#14141c',
  TunaDarkest: '#0f0f15'
};

export const definedTokens = {
  spacing: { XS: '4px', S: '16px', M: '32px', L: '64px', XL: '128px' },
  sizing: { XS: '16px', S: '100px', M: '300px', L: '600px', XL: '1024px' },
  fontSize: { XS: '12px', SM: '14px', MD: '16px', LG: '24px', XL: '32px' },
  textColor: customColours,
  color: customColours
};

// UI will alert you if breakpoints have changed and whether to accept changes or not
// Leaving in here to reference how to do this if needing custom breakpoints
// const breakpoints = [
//   {
//     id: 'desktop',
//     query: '*',
//     displayName: 'All Sizes',
//     previewSize: '100%',
//     displayIcon: 'desktop' as const
//   },
//   {
//     id: 'tablet',
//     query: '<992px',
//     displayName: 'Tablet',
//     previewSize: '820px',
//     displayIcon: 'tablet' as const
//   },
//   {
//     id: 'mobile',
//     query: '<576px',
//     displayName: 'Mobile',
//     previewSize: '390px',
//     displayIcon: 'mobile' as const
//   }
// ];
